import { useEffect } from "react";

import { useAppAuth } from "~/lib/auth/app-auth";
import { useCanonicalUserIdentity } from "~/lib/auth/canonical-user-identity";
import { getSentryDsn } from "~/lib/env";
import type { AppRouterContext } from "~/lib/router-runtime";
import { setSentryUserContext } from "~/lib/sentry";

export function SentryIdentityController(props: {
  readonly context: AppRouterContext;
}) {
  const auth = useAppAuth();
  const sentryEnabled = Boolean(getSentryDsn());
  const identityQuery = useCanonicalUserIdentity(props.context, {
    enabled: sentryEnabled,
  });
  const canonicalUserId =
    auth.ready && auth.authenticated
      ? (identityQuery.data?.userId ?? null)
      : null;

  useEffect(() => {
    setSentryUserContext({
      authenticated: auth.ready && auth.authenticated,
      authSource: auth.source,
      canonicalUserId,
      privyUserId:
        canonicalUserId && auth.source === "privy"
          ? auth.transport.userId
          : null,
      walletAddress: canonicalUserId ? auth.transport.walletAddress : null,
    });
  }, [
    auth.authenticated,
    auth.ready,
    auth.source,
    auth.transport.userId,
    auth.transport.walletAddress,
    canonicalUserId,
  ]);

  return null;
}
